import { plugin, Mode } from 'light-component';
import { useTranslation } from '../../../i18n';
import { Thumbnail } from '../../component';
import { WidgetType } from '../types';
import { CalendarDesignMode } from './design';
import { CalendarViewMode } from './view';
import { CalendarInputMode } from './input';
import type { ReactElement } from 'react';
import type { CalendarProps } from './types';

export function Calendar(props: CalendarProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='CalendarIcon' title={t('Calendar')} toolTipContent={t('Calendar')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<CalendarDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<CalendarViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<CalendarInputMode {...props} />);
  }

  return null;
}

Calendar.prototype.type = WidgetType.CALENDER;
plugin.register({ kind: 'widget', component: Calendar });
